var _path, _path2, _path3, _ellipse, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpenseHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28205 2.83496H1.41026C1.30145 2.83496 1.1971 2.87363 1.12016 2.94246C1.04322 3.01129 1 3.10464 1 3.20199V15.6808C1 15.7782 1.04322 15.8715 1.12016 15.9404C1.1971 16.0092 1.30145 16.0479 1.41026 16.0479H12.8974C13.0062 16.0479 13.1106 16.0092 13.1875 15.9404C13.2645 15.8715 13.3077 15.7782 13.3077 15.6808V3.20199C13.3077 3.10464 13.2645 3.01129 13.1875 2.94246C13.1106 2.87363 13.0062 2.83496 12.8974 2.83496H10.0256",
    stroke: "#353C47",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.63636V2.81818H5.83393C5.84009 2.81818 5.84599 2.81627 5.85034 2.81286C5.8547 2.80945 5.85714 2.80482 5.85714 2.8V2.09091C5.85714 1.94765 5.89317 1.80579 5.96317 1.67344C6.03317 1.54108 6.13576 1.42082 6.2651 1.31952C6.39444 1.21822 6.54799 1.13786 6.71698 1.08304C6.88597 1.02822 7.06709 1 7.25 1C7.43291 1 7.61403 1.02822 7.78302 1.08304C7.95201 1.13786 8.10556 1.21822 8.2349 1.31952C8.36424 1.42082 8.46683 1.54108 8.53683 1.67344C8.60683 1.80579 8.64286 1.94765 8.64286 2.09091V2.8C8.64286 2.81018 8.65307 2.81818 8.66607 2.81818H10.5V4.63636C10.5 4.73281 10.4511 4.8253 10.364 4.89349C10.2769 4.96169 10.1589 5 10.0357 5H4.46429C4.34115 5 4.22306 4.96169 4.13599 4.89349C4.04892 4.8253 4 4.73281 4 4.63636Z",
    stroke: "#353C47",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.70752H7.61538M3 10.3591H9.15385M3 12.0107H6.84615",
    stroke: "#353C47",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.25,
    cy: 13.1293,
    rx: 3.75,
    ry: 3.87097,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.1298C16.5 15.0066 15.0301 16.5007 13.25 16.5007C11.4699 16.5007 10 15.0066 10 13.1298C10 11.2529 11.4699 9.75879 13.25 9.75879C15.0301 9.75879 16.5 11.2529 16.5 13.1298Z",
    stroke: "#353C47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0967 11.9453V14.1313H14.6592",
    stroke: "#353C47",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseHistory);
export default __webpack_public_path__ + "static/media/expenseHistory.056808b7100fae46f7b7a61fabe379ca.svg";
export { ForwardRef as ReactComponent };